/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupListStatus =
  (typeof ErrorGroupListStatus)[keyof typeof ErrorGroupListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupListStatus = {
  ignored: "ignored",
  open: "open",
  resolved: "resolved",
} as const;
